:host {
  display: block;
  max-width: 100%;
  --apex-legend-cursor: pointer;
  --apex-legend-text-color: var(--blue-layout-400-primary);
}

.wrapper {
  width: 100%;
  height: 100%;
}
